import { api } from '../utils/api';

export const validatePromocode = async (hotelId: number, promocode: string) => {
  const path = `/api/v1/check-promocode/${hotelId}?` + new URLSearchParams({ promocode });
  return api.get<{ status: boolean }>(path);
};
